import { FC } from 'react'
import { ChevronLeft } from 'lucide-react'
import { Button } from '../../../ui/Button'
import VehicleData from '../proposalAdjustments/VehicleData'
import { ProposalQuoteOption } from '@/types'

interface RequestLeaseReviewContentProps {
  proposal: ProposalQuoteOption
  onBack: () => void
  onConfirm: () => void
  isSubmitting: boolean
}

// Pantalla intermedia "Revisa los detalles" que se muestra antes de crear
// la credit application a partir de la 2da solicitud del usuario en
// adelante (ver PendingProposalsContent.isFirstRequest) — la 1ra solicitud
// conserva el comportamiento inmediato de siempre.
export const RequestLeaseReviewContent: FC<RequestLeaseReviewContentProps> = ({
  proposal,
  onBack,
  onConfirm,
  isSubmitting,
}) => {
  return (
    <>
      <button
        type="button"
        onClick={onBack}
        className="flex items-center gap-1.5 border border-gray-300 rounded-full px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-olr-grey-1 transition-colors mb-4"
      >
        <ChevronLeft size={16} />
        Regresar
      </button>

      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        Solicitar nuevo arrendamiento
      </h2>

      <h3 className="text-xl font-bold text-gray-900 mb-4">
        Revisa los detalles
      </h3>

      <div className="bg-white border border-olr-grey-2 rounded-lg overflow-hidden mb-6">
        <VehicleData generalInfo={proposal.vehicleData} periodoLabel="Plazo" />
      </div>

      <div className="flex justify-start">
        <Button
          type="button"
          onClick={onConfirm}
          isLoading={isSubmitting}
          className="px-12 py-3 min-w-[230px]"
        >
          Solicitar
        </Button>
      </div>
    </>
  )
}

export default RequestLeaseReviewContent
